import { Navigate, useRoutes } from 'react-router-dom'
import { lazyWithRetry } from './lib/lazy-retry'

const LoginPage = lazyWithRetry(() => import('./pages/LoginPage'))
const MainLayout = lazyWithRetry(() => import('./layouts/MainLayout'))
const Dashboard = lazyWithRetry(() => import('./pages/Dashboard'))
const AudioManagement = lazyWithRetry(() => import('./pages/AudioManagement'))
const AIStudio = lazyWithRetry(() => import('./pages/AIStudio'))
const CategoryManagement = lazyWithRetry(() => import('./pages/CategoryManagement'))
const UserManagement = lazyWithRetry(() => import('./pages/UserManagement'))
const Settings = lazyWithRetry(() => import('./pages/Settings'))

export const routes = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'content/audios',
        element: <AudioManagement />,
      },
      {
        path: 'content/categories',
        element: <CategoryManagement />,
      },
      {
        path: 'ai-studio',
        element: <AIStudio />,
      },
      {
        path: 'users',
        element: <UserManagement />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
    ],
  },
]

export function Router() {
  return useRoutes(routes)
}
